import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManageShiftsEditPageRoutingModule } from './manage-shifts-edit-routing.module';

import { ManageShiftsEditPage } from './manage-shifts-edit.page';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManageShiftsEditPageRoutingModule,
    BhInputComponentModule,
    ReactiveFormsModule,
    PipesModule
  ],
  declarations: [ManageShiftsEditPage]
})
export class ManageShiftsEditPageModule {}
